@if (!openFilter) {
  <div
    class="expert-underlay"
    [ngClass]="{ 'blocked-container': expert.blocked, 'show-affiliations-extra-margin': showAffiliations }"
    [attr.data-test-id]="`expert-list-item-${expert.expertId}`"
  >
    <div class="expert-underlay-actions" (appClickOutside)="closeActions()">
      <div class="expert-underlay-action">
        @if (expert.rejection.admin || expert.rejection.client || expert.rejection.expert) {
          <mat-icon class="pull-left" (click)="emitToggleAdminRejectStatusSignal()">thumb_up</mat-icon>
        }
        @if (!expert.rejection.admin && !expert.rejection.client && !expert.rejection.expert) {
          <mat-icon (click)="emitToggleAdminRejectStatusSignal()">thumb_down</mat-icon>
        }
      </div>
    </div>
    <div data-test-id="expert-list-detail" class="expert-overlay" [ngClass]="{ 'reduce-width': showActions }">
      <div class="select-grid-item">
        @if (expert.isSelectable) {
          <span
            class="check-box"
            data-test-id="expert-list-selected-check-box"
            (click)="emitSelectExpertSignal(expert)"
          >
            @if (!expert.isSelected) {
              <mat-icon>check_box_outline_blank</mat-icon>
            }
            @if (expert.isSelected) {
              <mat-icon class="checked">check_box</mat-icon>
            }
          </span>
        } @else {
          <span class="check-box">
            <mat-icon class="disabled">highlight_off</mat-icon>
          </span>
        }
        <mat-icon
          class="open-actions"
          [ngClass]="showActions ? 'rotate-opposite' : ''"
          (click)="toggleShowActions($event)"
          >arrow_right_alt</mat-icon
        >
      </div>
      <div class="identity-grid-item">
        <div class="flex justify-start content-center items-center flex-row gap-[5px]">
          <span class="expert-name">
            <div class="flex justify-start content-center items-center flex-row gap-0.5">
              @if (expert.blocked) {
                <mat-icon class="blocked" matTooltip="Blocked" data-test-id="expert-blocked-icon"> block </mat-icon>
              }
              @if (expert.rejection.expert) {
                <mat-icon
                  fontSet="material-icons-outlined"
                  class="rejected"
                  matTooltip="Expert rejected"
                  data-test-id="expert-declined-project-icon"
                >
                  do_not_disturb_off
                </mat-icon>
              }
              @if (expert.rejection.admin) {
                <mat-icon class="rejected" matTooltip="Admin rejected" data-test-id="expert-admin-rejected-icon">
                  clear
                </mat-icon>
              }
              @if (expert.rejection.client) {
                <mat-icon class="rejected" matTooltip="Client rejected" data-test-id="expert-client-rejected-icon">
                  thumb_down
                </mat-icon>
              }
              @if (expert.clientApproved) {
                <mat-icon class="approvedIcon" matTooltip="Client approved" data-test-id="expert-client-approved-icon">
                  check_circle_outline
                </mat-icon>
              }
              @if (expert.onHold) {
                <mat-icon class="onHoldIcon" matTooltip="On hold">pause_circle</mat-icon>
              }
              <div data-test-id="expert-list-expert-name">
                {{ expertName }}
              </div>
            </div>
            @if (expert.firstNameAlias || expert.lastNameAlias) {
              <div>({{ expertAlias }})</div>
            }
          </span>
          <div class="flex flex-row">
            @if (identityVerificationRequestLastSent) {
              <mat-icon
                matTooltip="Identity verification request sent: {{
                  identityVerificationRequestLastSent | date: 'mediumDate'
                }}"
              >
                fingerprint
              </mat-icon>
            }
            @for (engagement of expert.engagements; track engagement) {
              <mat-icon
                matTooltip="{{ engagement.engagementType }} {{ engagement.dateOfEngagement | date: 'shortDate' }} {{
                  engagement.amountOwed
                }}{{ engagement.currency }} {{
                  engagement.paymentType === 'thirdParty'
                    ? `Third party: ${engagement.paymentProvider}`
                    : `${engagement.paymentType} ${engagement.paymentStatus}`
                }}"
                class="ct-engagementIndicator"
                [style.color]="getEngagementStatusColor(engagement)"
              >
                attach_money</mat-icon
              >
            }
          </div>
        </div>
        <div class="source-search-code-row">
          @if (expert.source) {
            <span
              class="source-pill"
              data-test-id="expert-list-expert-source"
              [matTooltip]="expert.source | sourceDisplayName"
              [ngClass]="{
                'pdl-commercial-pill': ['pdl-commercial', 'pdl-enrichment'].includes(expert.source),
                'deep-next-pill': expert.source === 'deep-next',
                'deep-pill': ['deep', 'deep3'].includes(expert.source),
                'hist-pill': expert.source === 'historical',
                'netw-pill': expert.source === 'network',
                'manu-pill': expert.source === 'manualUpload',
                'manu-third-party': expert.source === 'third-party',
              }"
              >{{ expert.source | sourceDisplayName: true }}</span
            >
          }
          @for (mvpType of expert.mvpTypes; track mvpType) {
            <span
              class="source-pill mvp-pill"
              [attr.data-test-id]="`expert-list-mvp-type`"
              [matTooltip]="mvpType | mvpExpertTypeTooltip"
              >{{ mvpType | mvpExpertType }}
            </span>
          }
          <span class="search-id" data-test-id="expert-list-expert-search-id"> - {{ expert.searchId }}</span>
        </div>
      </div>

      <div class="details-grid-item">
        <app-country-box [verifiedCountry]="expert.country"></app-country-box>
        <app-contact-info-box class="contact-info-box-width" [expert]="expert"></app-contact-info-box>
        @if (
          expert.connectPhase === 'outreach' ||
          expert.connectPhase === 'sentToClient' ||
          expert.connectPhase === 'accepted'
        ) {
          <app-availability-box
            [timezoneName]="expert.timezoneName"
            [requestedAnotherTime]="!!additionalAvailabilityRequestLastSent"
            [availabilities]="expert.availabilities"
            [callTime]="expert.callTime"
          >
          </app-availability-box>
        }
        @if (expert.connectPhase === 'accepted' && expert.currency && expert.primaryEmail) {
          <button
            class="button button--secondary schedule-button"
            data-test-id="opportunity-schedule-call"
            [routerLink]="['/admin', 'experts', expert.expertId]"
            [queryParams]="{ tab: 'Conferences' }"
          >
            Schedule call
          </button>
        }
        @if (expert.connectPhase === 'accepted' && (!expert.currency || !expert.primaryEmail)) {
          <div style="display: flex" matTooltip="Need an expert currency & poc email">
            <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
            <button
              class="button button--secondary schedule-button"
              data-test-id="opportunity-schedule-call"
              [disabled]="true"
            ></button>
          </div>
        }
        @if (expert.connectPhase === 'scheduled' || expert.connectPhase === 'completed') {
          <app-scheduled-box [expert]="expert"> </app-scheduled-box>
        }
        @if (
          expert.screenerConfig &&
          (expert.connectPhase === 'screener' || expert.rejection.admin || expert.rejection.expert)
        ) {
          <app-screener-box [screenerConfig]="expert.screenerConfig" (click)="emitShowScreenerResults()">
          </app-screener-box>
        }
        @if (
          opportunity.projectType === 'Qual' &&
          client.features?.expertTrainingRequired &&
          expert.connectPhase === 'screener'
        ) {
          <app-compliance-training-box [complianceTraining]="expert.training"> </app-compliance-training-box>
        }
      </div>
      <div class="expand-grid-item">
        <a [routerLink]="['/admin', 'experts', expert.expertId]">
          <mat-icon class="expand-icon" id="fullscreen-icon" data-test-id="opportunity-open-expert">
            fullscreen
          </mat-icon>
        </a>
      </div>
    </div>
  </div>
} @else {
  <div
    class="ghost-expert-details"
    data-test-id="expert-list-search-result"
    [ngClass]="showActions ? 'reduce-width' : ''"
  >
    <div class="phase-div">
      <span class="phase-box">
        <span data-test-id="expert-list-search-result-expert-phase">{{ expert.connectPhase }}</span>
      </span>
    </div>
    <div class="identity-grid-item reduce-opacity">
      <span class="expert-name" data-test-id="expert-list-search-result-expert-name">{{ expert | expertName }}</span>
    </div>

    <div class="details-grid-item reduce-opacity">
      <app-country-box
        data-test-id="expert-list-search-result-expert-countries"
        [verifiedCountry]="expert.country"
      ></app-country-box>
      @if (expert.rejection.admin || expert.rejection.client || expert.rejection.expert) {
        <div class="reason-for-rejection-div">
          <span class="rejection-label">Reason for rejection</span>
          <mat-icon matTooltip="{{ expert.reasonForRejection ? expert.reasonForRejection : 'Rejected Expert' }}"
            >info
          </mat-icon>
        </div>
      }
      <app-contact-info-box class="contact-info-box-width" [expert]="expert"></app-contact-info-box>
      @if (
        expert.connectPhase === 'outreach' ||
        expert.connectPhase === 'sentToClient' ||
        expert.connectPhase === 'accepted'
      ) {
        <app-availability-box
          [timezoneName]="expert.timezoneName"
          [requestedAnotherTime]="!!additionalAvailabilityRequestLastSent"
          [availabilities]="expert.availabilities"
          [callTime]="expert.callTime"
        >
        </app-availability-box>
      }
      @if (expert.connectPhase === 'scheduled') {
        <app-scheduled-box [expert]="expert"> </app-scheduled-box>
      }
    </div>
    <div class="go-to-expert-div">
      <button
        class="button secondary"
        data-test-id="expert-list-search-result-go-to-expert"
        (click)="emitNavigateToExpertSignal(expert)"
      >
        Go to expert
      </button>
    </div>
  </div>
}
